import _default from './commaLists';
export { _default as default };
